var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalBasic01 = function SvgCalBasic01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cal_basic-01_svg2__a",
    x1: 80.13,
    x2: 226.17,
    y1: -28.5,
    y2: 134.65,
    gradientTransform: "matrix(1 0 0 -1 0 201)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_basic-01_svg2__a",
    id: "cal_basic-01_svg2__b",
    x1: 31.51,
    x2: 177.55,
    y1: 15.03,
    y2: 178.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_basic-01_svg2__a",
    id: "cal_basic-01_svg2__c",
    x1: 7.08,
    x2: 153.12,
    y1: 36.89,
    y2: 200.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_basic-01_svg2__a",
    id: "cal_basic-01_svg2__d",
    x1: 33.02,
    x2: 179.06,
    y1: 13.67,
    y2: 176.82
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_basic-01_svg2__a",
    id: "cal_basic-01_svg2__e",
    x1: 58.82,
    x2: 204.86,
    y1: -9.42,
    y2: 153.73
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_basic-01_svg2__a",
    id: "cal_basic-01_svg2__f",
    x1: 28.39,
    x2: 174.43,
    y1: 17.82,
    y2: 180.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#cal_basic-01_svg2__a",
    id: "cal_basic-01_svg2__g",
    x1: 54.33,
    x2: 200.37,
    y1: -5.4,
    y2: 157.75
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.39 171.75h26.16c1.81 0 3.29-1.47 3.29-3.29V142.3c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29m3.29-26.16h19.59v19.59h-19.59z",
    style: {
      fill: "url(#cal_basic-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.72 18.97h-5.48v-6.04c0-7.1-5.78-12.88-12.88-12.88h-3.95c-7.1 0-12.88 5.78-12.88 12.88v6.04H62.1v-6.04C62.1 5.83 56.32.05 49.22.05h-3.95c-7.1 0-12.88 5.78-12.88 12.88v6.04h-5.11C12.24 18.97 0 31.2 0 46.25v126.42c0 15.04 12.24 27.28 27.28 27.28h145.44c15.04 0 27.28-12.24 27.28-27.28V46.25c0-15.04-12.24-27.28-27.28-27.28m-28.63-6.04c0-3.48 2.83-6.3 6.3-6.3h3.96c3.48 0 6.3 2.83 6.3 6.3v20.56c0 3.48-2.83 6.3-6.3 6.3h-3.96c-3.48 0-6.3-2.83-6.3-6.3zm-105.14 0c0-3.48 2.83-6.3 6.3-6.3h3.96c3.48 0 6.3 2.83 6.3 6.3v20.56c0 3.48-2.83 6.3-6.3 6.3h-3.96c-3.48 0-6.3-2.83-6.3-6.3zM6.57 46.25c0-11.42 9.29-20.71 20.71-20.71h5.11v7.94c0 7.1 5.78 12.88 12.88 12.88h3.96c7.1 0 12.88-5.78 12.88-12.88v-7.94h75.43v7.94c0 7.1 5.78 12.88 12.88 12.88h3.96c7.1 0 12.88-5.78 12.88-12.88v-7.94h5.48c11.42 0 20.71 9.29 20.71 20.71v26.89H6.57zm186.86 126.42c0 11.42-9.29 20.71-20.71 20.71H27.27c-11.42 0-20.71-9.29-20.71-20.71V79.7h186.86v92.96Z",
    style: {
      fill: "url(#cal_basic-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.19 128.87h26.16c1.81 0 3.29-1.47 3.29-3.29V99.42c0-1.81-1.47-3.29-3.29-3.29H40.19c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29m3.29-26.16h19.59v19.59H43.48z",
    style: {
      fill: "url(#cal_basic-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92 128.87h26.16c1.81 0 3.29-1.47 3.29-3.29V99.42c0-1.81-1.47-3.29-3.29-3.29H86.92c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29m3.28-26.16h19.59v19.59H90.2z",
    style: {
      fill: "url(#cal_basic-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.39 128.87h26.16c1.81 0 3.29-1.47 3.29-3.29V99.42c0-1.81-1.47-3.29-3.29-3.29h-26.16c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29m3.29-26.16h19.59v19.59h-19.59z",
    style: {
      fill: "url(#cal_basic-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.19 171.75h26.16c1.81 0 3.29-1.47 3.29-3.29V142.3c0-1.81-1.47-3.29-3.29-3.29H40.19c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29m3.29-26.16h19.59v19.59H43.48z",
    style: {
      fill: "url(#cal_basic-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92 171.75h26.16c1.81 0 3.29-1.47 3.29-3.29V142.3c0-1.81-1.47-3.29-3.29-3.29H86.92c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29m3.28-26.16h19.59v19.59H90.2z",
    style: {
      fill: "url(#cal_basic-01_svg2__g)"
    }
  }));
};
export default SvgCalBasic01;